import { postTypeGQLFields } from '../post/postType.fields.js';
import { actionPermissionGQLFields, } from './actionPermissions.fields.js';
const BASIC_SPACE_AUTH_MEMBER_PROPS_FIELDS = {};
const ALL_SPACE_AUTH_MEMBER_PROPS_FIELDS = {
    permissions: 'basic',
    availablePostTypes: 'basic',
};
export function spaceAuthMemberPropsGQLFields(fields) {
    if (fields === 'basic')
        fields = BASIC_SPACE_AUTH_MEMBER_PROPS_FIELDS;
    if (fields === 'all')
        fields = ALL_SPACE_AUTH_MEMBER_PROPS_FIELDS;
    return `
    context
    scopes
    membershipStatus
    ${fields.permissions
        ? `
      permissions {
        ${actionPermissionGQLFields(fields.permissions)}
      }
    `
        : ``}
    ${fields.availablePostTypes
        ? `
      availablePostTypes {
        ${postTypeGQLFields(fields.availablePostTypes)}
      }`
        : ''}
  `;
}
//# sourceMappingURL=spaceAuthMemberProps.fields.js.map